var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExercisesDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#paint0_linear_87_1311)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 27.9916C43.943 35.5876 38.6519 42.1413 31.2215 43.6476C26.4368 44.6185 22.0656 43.5762 18.1864 40.6064C15.0132 38.1791 13.1092 34.9522 12.3034 31.0471C11.8399 28.8197 11.9326 26.5994 12.4104 24.3863C12.553 23.7224 13.1306 23.344 13.751 23.4725C14.3856 23.601 14.7493 24.215 14.5924 24.9289C14.35 26.0212 14.2359 27.1277 14.2644 28.2486C14.3357 31.4754 15.3982 34.3311 17.459 36.8083C19.5555 39.3213 22.2224 40.9419 25.4456 41.4916C30.594 42.3697 34.9581 40.8348 38.4308 36.9226C40.2634 34.8522 41.2903 32.3821 41.6326 29.6407C42.3243 24.1793 39.5504 18.7036 34.737 16.0193C31.5923 14.2631 28.2551 13.8347 24.7467 14.6271C24.0836 14.7771 23.4775 14.4344 23.3348 13.8276C23.1851 13.185 23.563 12.6139 24.2405 12.4497C32.7475 10.3865 41.3972 15.6195 43.4937 24.1079C43.6149 24.6005 43.729 25.1002 43.7861 25.6071C43.8788 26.3924 43.9287 27.192 44 27.9916Z",
    fill: "#89CF77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9947 30.383C27.2568 29.1122 28.4905 27.8843 29.717 26.6492C30.8294 25.5284 31.9418 24.4075 33.0613 23.301C33.7174 22.6513 34.7371 22.8869 34.9724 23.7364C35.1008 24.2076 34.9439 24.5931 34.6016 24.9358C33.2467 26.2851 31.8919 27.6487 30.5441 28.998C29.339 30.2045 28.1339 31.411 26.9288 32.6175C26.3084 33.2386 25.6952 33.2386 25.0819 32.6246C23.8269 31.3682 22.5719 30.1117 21.3169 28.8552C20.9888 28.5268 20.8533 28.1413 20.996 27.6844C21.1386 27.2275 21.4666 26.9705 21.923 26.9062C22.3152 26.8491 22.6432 27.0133 22.9213 27.2917C23.941 28.3126 24.9536 29.3335 25.9947 30.383Z",
    fill: "#89CF77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1831 16.2331C20.1831 16.4544 20.0333 16.7471 19.7552 16.9684C18.65 17.8108 17.6944 18.796 16.8601 19.9026C16.4465 20.4523 15.7691 20.5237 15.2628 20.1239C14.7637 19.7312 14.6924 19.0959 15.0845 18.5462C16.0116 17.2683 17.1097 16.1617 18.3647 15.2122C18.7355 14.9338 19.142 14.8624 19.5698 15.0837C19.9763 15.2907 20.1902 15.6263 20.1831 16.2331Z",
    fill: "#89CF77"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_1311",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D2107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2A09"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercisesDark);
export default __webpack_public_path__ + "static/media/exercises_dark.647bf14391f8aa4f80251d77d7bf7510.svg";
export { ForwardRef as ReactComponent };